import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useMyGymMessages = (gymId: string | null | undefined) => {
  return useQuery({
    queryKey: ["my-gym-messages", gymId],
    enabled: !!gymId,
    queryFn: async () => {
      const { data: userData } = await supabase.auth.getUser();
      if (!userData.user) return [];

      const { data, error } = await supabase
        .from("gym_messages")
        .select("id, content, created_at, is_read")
        .eq("gym_id", gymId!)
        .eq("user_id", userData.user.id)
        .order("created_at", { ascending: false })
        .limit(3);

      if (error) throw error;
      return data ?? [];
    },
  });
};
